import * as types from "./types";

export default {
  [types.NPS_SURVEY]: (state) => {
    return state.npsSurvey;
  },
};
